import { type } from "../../types"

export const setLoader =(loading) => (dispatch) => {

    dispatch({
        type :type.SET_LOADER,
        payload: loading
    })
}